import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sk_cart") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("sk_cart", JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const clone = [...prev];
        clone[idx] = { ...clone[idx], quantity: clone[idx].quantity + qty };
        return clone;
      }
      return [...prev, { product_id: product.id, name: product.name, price: product.price, image_url: product.image_url, quantity: qty }];
    });
  };
  const update = (pid, qty) =>
    setItems((prev) => prev.map((i) => (i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i)));
  const remove = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, update, remove, clear, subtotal, count }}>{children}</CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
